import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import CustomNavbar from './Navbar/Navbar';
import Sidebar from './Sidebar/Sidebar';

const ProveedorLayout = ({ onLogout, username }) => {
  const [sidebarOpen] = useState(false);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar isOpen={sidebarOpen} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <CustomNavbar
          onLogout={onLogout}
          username={username}
        />
        <main style={{ paddingTop: '70px', paddingLeft: sidebarOpen ? '250px' : '0', transition: 'padding 0.3s' }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProveedorLayout;